import { React, useEffect } from "react";
import { Helmet } from "react-helmet";
import {SectionHeader} from "./Header";
import Transitions from "./Transitions";
import Form from "./Form";

function Contact() {

  // useEffect(() => {
  //   document.title = "ETCHNG | About";  
  
  // }, []);  

  
  return (
    <>
     <Helmet>
        <title>ETCHNG | Contact</title>
        <meta name="description" content="Contage page"/> 
        <meta name="keywords" content=" ETCHNG, medical illustrator, UX, contact"
        />
    </Helmet>
      <Transitions>
        <div className="wrapper">
          <div className="wrapper__inner">
            <SectionHeader
            textColour="#f55a59"
              smallText="Want to chat?"
              largeText="CONTACT ME"
            ></SectionHeader>
            <section className="content__wapper">
            <div className="work singleColumn">
              {/* <div className="wideColumn"> */}
                <Form />
              {/* </div> */}
              {/* <div className="narrowColumn"> */}
              <br/>
                <p>
                  Alternatively, feel free to reach out on{" "}
                  <strong>
                    <a
                      href="https://www.linkedin.com/in/eric-chung-456ab38a/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      LinkedIn
                    </a>
                  </strong>
                  , in case you don't hear back.
                </p>
            </div></section>
          </div>
        </div>
      </Transitions>
    </>
  );
}

export default Contact;
